import { Component } from '@angular/core'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { Interval } from '../../../../controls/interval-control/interval-control.component'

@Component({
  selector: 'jml-lib-interval-cell',
  templateUrl: './interval-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class IntervalCellComponent extends InlineEditCellDirective {
  displayIntervalDialog = false
  isFormValid = false
  interval: Interval

  /* True while the cell is completing the edit event. The dialog fires an 'onHide' event both when clicking the close and the submit button.
   * In the latter case we dont want to restore the cells original content and need to prevent the abortCellEdit function from being called.
   */
  isSaving = false

  triggerEdit() {
    // Since the address is not a primitive we need to make a real copy
    this.originalContent = Object.assign({}, this.rowData[this.fieldName])
    // TODO: Not sure how the interval comes from backend. ADD transofmrtion if neccessary
    this.interval = Object.assign({}, this.rowData[this.fieldName])
    this.displayIntervalDialog = true
  }

  onSave() {
    const newRowData = { ...this.rowData, [this.fieldName]: this.interval }
    this.completeCellEdit.emit({ data: newRowData, field: this.fieldName })
    this.isSaving = true
    this.displayIntervalDialog = false
  }

  onHide() {
    if (this.isSaving) {
      this.isSaving = false
    } else {
      this.abortCellEdit(null)
    }
  }

  handleFormState(event: { value: Interval; valid: boolean }) {
    this.isFormValid = event.valid
    this.interval = event.value
  }
}
